export default [
    {
        path: "/voucher/canteen/recipe",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/List.vue"),
        name: "recipe.canteen.list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe/create",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/Create.vue"),
        name: "recipe.canteen.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe/purchase/:id",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/Purchase.vue"),
        name: "recipe.canteen.purchase.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe/purchase",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/ManyToMany.vue"),
        name: "recipe.canteen.purchase",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe/:id/edit",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/Edit.vue"),
        name: "recipe.canteen.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe/:id/view",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/View.vue"),
        name: "recipe.canteen.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe-one-to-many",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/OneToMany.vue"),
        name: "recipe.canteen.one.to.many",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe-one-to-many-create",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/OneToManyCreate.vue"),
        name: "recipe.canteen.one.to.many.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe-one-to-many-purchase/purchase/:id",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/OneToManyPurchase.vue"),
        name: "canteen-recipe-one-to-many-purchase",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/recipe-one-to-many/:id/edit",
        component: () => import("@/App/Canteen/Voucher/Recipe/Components/OneToManyEdit.vue"),
        name: "canteen-recipe-one-to-many-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
